<template>
    <div>
        <div class="progress" style="height: 4px">
            <div
                class="progress-bar bg-blue"
                role="progressbar"
                :style="progressStyle(session.progress_percent)"
                :aria-valuenow="session.progress_percent"
                aria-valuemin="0"
                aria-valuemax="100"
                aria-label="Your progress"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CommunityCaseProgressBar",
    props: {
        session: {
            type: Object,
            required: true,
        },
    },
    methods: {
        progressStyle(progress) {
            if (progress == 0) {
                progress = 1
            }
            return {
                width: progress + "%",
            }
        },
    }
}
</script>